import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import PortletBody from '../../app/components/portlet/PortletBody';
import { getRandomInteger } from '../../utils/helper';

const HiringRequestsListingSekeleton = ({ columns, className }) => {
  return (
    <PortletBody className={`p-1 py-0 ${className}`}>
      <div className="flex-center mb-2">
        <div className="flex-grow-1">
          <Skeleton height={35} width={'60%'} className="me-2" />
        </div>
        <div className="d-flex">
          <div>
            <Skeleton height={35} className="me-2 mt-2" width={40} />
          </div>
          <Skeleton height={35} className="me-2 mt-2" width={40} />
        </div>
      </div>

      <div className="border border-muted rounded p-1 mt-3">
        <table className="table">
          <thead>
            <tr>
              {columns.map((col, ind) => (
                <th className={`${ind===0? 'text-left':'text-center'}`} key={`column-${ind}`}>
                  <Skeleton height={15} width={70} className="mt-2" />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from(new Array(4)).map((i, ind) => (
              <tr key={`tbody-${ind}`} className="justify-content-center">
                {/* {columns.map((col) => ( */}
                <td>
                  <Skeleton height={25} width={70} className="mt-2" />
                  <Skeleton height={10} className=" mt-2" />
                </td>
                <td className="text-center ">
                  <Skeleton height={25} width={100} className="mt-3" />
                </td>
                <td className="text-center ">
                  <Skeleton height={25} width={25} className="mt-3" />
                </td>
                <td className="text-center ">
                  <Skeleton height={25} width={25} className="mt-3" />
                </td>
                <td className="text-center ">
                  <Skeleton height={15} width={`55%`} className=" mt-3" />
                </td>
                <td className="text-center ">
                  <Skeleton
                    height={15}
                    width={`${getRandomInteger(70)}%`}
                    className=" mt-3"
                  />
                </td>
                <td className="text-center ">
                  <Skeleton height={25} width={`60%`} className=" mt-3" />
                </td>
                <td className="text-center ">
                  <Skeleton height={15} width={`50%`} className=" mt-4" />
                </td>
                <td className="text-center ">
                  <Skeleton height={15} width={`50%`} className=" mt-4" />
                </td>
                <td className="text-center ">
                  <Skeleton height={15} width={`50%`} className=" mt-4" />
                </td>
                <td className="text-center ">
                  <Skeleton height={15} width={`50%`} className=" mt-4" />
                </td>
                <td className="text-center ">
                  <Skeleton
                    height={25}
                    width={`15%`}
                    className=" me-2  mt-4"
                    inline={true}
                  />
                  <Skeleton
                    height={25}
                    width={`15%`}
                    className=" me-2"
                    inline={true}
                  />
                  <Skeleton
                    height={25}
                    width={`15%`}
                    className=" me-2  mt-4"
                    inline={true}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-end  mt-2">
        <Skeleton height={30} className="me-2" width={100} />
        {Array.from(new Array(4)).map((i, ind) => (
          <Skeleton
            height={30}
            key={`row-${ind}`}
            className="me-2"
            width={30}
          />
        ))}
      </div>
    </PortletBody>
  );
};

export default HiringRequestsListingSekeleton;
